import { Card, Form, Col} from '@deere/ux.uxframe-react'
import React from 'react'
import { useTranslation } from "react-i18next";
import { ProgressIndicator } from '../ProgressIndicator'
import { useUserInfo } from '../../providers/userProvider';
import { CRS_REQUEST_STATUS_OBJ, SCBM_USER_TYPE, CM_ADMIN, CM_IF_ADMIN} from '../../utils/surveyLiterals'

export default function UploadCMRTCard({ loadingBar, upload, loading, fielKey, status, isAuthMethodOkta}) {
    const { t } = useTranslation();
    const userInfo = useUserInfo();

    const isCompleted = () =>{ 
        return status === CRS_REQUEST_STATUS_OBJ.COMPLETE ? true : false;
    }

    const isGeneralUser = () =>{ 
        if (isAuthMethodOkta !== undefined && !isAuthMethodOkta) 
            return false;
        else
            return userInfo.userType === SCBM_USER_TYPE.SALARY && !userInfo.roles.includes(CM_ADMIN) && !userInfo.roles.includes(CM_IF_ADMIN);
    }
    
    return (<div>
        <Card>
            <Card.Body>
                <Card.Title className='pb-3 font-weight-bold'>
                    3. {t('cm_lbl_upload_template')}
                </Card.Title>
                <Form.Label>{t('cm_lbl_upload_note')}</Form.Label>
                <Form.Row className="d-block mb-4">
                    <Col>
                        <Form.Group>
                            <Form.Control key={fielKey} type="file" id="cmrt-template" onChange={(event) => { upload(event.target.files) }} disabled={loading || isCompleted() || isGeneralUser()} />
                        </Form.Group>
                    </Col>
                    {loadingBar ? <ProgressIndicator /> : null}
                </Form.Row>                
            </Card.Body>
        </Card>
    </div>);
}
